module.exports = __webpack_public_path__ + "static/img/super-chat-pass-off.627a50f1.png";